<template lang="pug">
#attention_heatmap
  template(v-if="$store.state[this.state_name].show_attention_heatmap")
    .gradient(:style="{ backgroundImage: gradient}")
    .chart_line(v-for="(v, i) in this.$store.state[this.state_name].attention_data", :style="{ top: marginTop(i) }")
      .balloon_bottom(:style="{ marginLeft: BalloonLeft(v), top: '50px' }")
        span.balloon_type attention
        span.balloon_text {{v}}%
      .chart_unit
        .a_chart_bold(:style="{ width: widthBold(v) }")
        .a_chart_thin(:style="{ width: widthThin(v) }")
</template>

<script>
import Vue from "vue";

export default {
  props: {
    token: String,
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data() {
    return {
      page_height: 0,
      show_heatmap: false,
    };
  },
  methods: {
    async init() {
      this.$store.commit(`${this.state_name}/setToken`, this.token);
      await this.$store.dispatch(`${this.state_name}/getAttention`);
    },
    marginTop(i) {
      //console.log(i, this.page_height);
      return (this.$store.state[this.state_name].page_height / 100) * i - 45 + "px";
    },
    widthBold(v) {
      //console.log(i, this.page_height);
      return v + "%";
    },
    widthThin(v) {
      //console.log(i, this.page_height);
      return 100 - v + "%";
    },
    BalloonLeft(v) {
      return "calc(" + v + "% - 42px)";
    },
  },
  async mounted() {
    await Vue.nextTick();
    await this.init();
  },
  watch: {
    device: async function (val) {
      //await this.initIframe()
    },
    show_attention_heatmap: async function (val) {
      if (val) {
        await this.$store.dispatch(`${this.state_name}/getAttention`);
      }
    },
  },
  components: {},
  computed: {
    gradient() {
      return this.$store.getters[`${this.state_name}/attention_gradient`];
    },
    device() {
      return this.$store.state[this.state_name].device;
    },
    show_attention_heatmap() {
      return this.$store.state[this.state_name].show_attention_heatmap;
    },
  },
};
</script>
<style lang="scss" scoped></style>
